import React, { useState, useEffect } from "react"
import "./style.css"
import encryptClass from "../../../inc/Controllers/encrypt.class"
import api from "../../../services/api"

export default function NpsRating({ isOpen, onClose }) {
  const [rating, setRating] = useState(0)
  const [usabilityRating, setUsabilityRating] = useState(null)
  const [feedback, setFeedback] = useState("")
  const [submitted, setSubmitted] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleRatingClick = (selectedRating) => {
    setRating(selectedRating)
  }

  const handleUsabilityClick = (value) => {
    setUsabilityRating(value)
  }

  const handleSubmit = () => {
    if (!rating || usabilityRating === null || isSubmitting) return

    setIsSubmitting(true)

    const pacientFound = sessionStorage.getItem("patientFound")
    const data = JSON.parse(encryptClass.reveal(pacientFound))
    const { nome, email } = data

    api
      .post("/pesquisa", {
        nome,
        email,
        rating,
        usabilityRating,
        feedback,
      })
      .then(() => {
        setSubmitted(true)
        setTimeout(() => onClose(), 2000)
      })
      .finally(() => setIsSubmitting(false))
  }

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("nps-modal-backdrop")) {
      onClose()
    }
  }

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "unset"
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div className="nps-modal-backdrop" onClick={handleBackdropClick}>
      <div className={`nps-modal ${isOpen ? "nps-modal-open" : ""}`}>
        <div className="nps-modal-handle"></div>

        <div className="nps-rating">
          {submitted ? (
            <div className="nps-success">
              <span className="nps-success-icon">✓</span>
              <p className="tanks-feed">Obrigado pelo seu feedback!</p>
            </div>
          ) : (
            <>
              <h3 className="nps-title">Como você avalia sua experiência?</h3>

              {/* Estrelas */}
              <div className="stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span
                    key={star}
                    className={`star ${star <= rating ? "selected" : ""}`}
                    onClick={() => handleRatingClick(star)}
                  >
                    ★
                  </span>
                ))}
              </div>

              {/* Textarea */}
              <textarea
                placeholder="Digite aqui suas sugestões ou críticas..."
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                rows={4}
              />

              {/* Usability Rating */}
              <div className="usability-section">
                <p className="usability-title">
                  De 0 a 10, o quão fácil é utilizar o Agendamento Online?
                </p>

                <div className="usability-grid">
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
                    <button
                      key={value}
                      className={`usability-btn ${
                        usabilityRating === value ? "selected" : ""
                      }`}
                      onClick={() => handleUsabilityClick(value)}
                    >
                      {value}
                    </button>
                  ))}
                </div>
              </div>

              <button
                onClick={handleSubmit}
                disabled={!rating || usabilityRating === null || isSubmitting}
                className="nps-submit-btn"
              >
                {isSubmitting ? "Enviando..." : "Enviar Avaliação"}
              </button>

              <button onClick={onClose} className="nps-cancel-btn">
                Fechar
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
